import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { authService } from "service/auth";
import { useAuth } from "context/AuthContext";
import { getCookie, setCookie } from "utils/cookieUtils";

import { ReactComponent as SvgIcon } from "assets/icons/elite-vacances/eliteVacances.svg";
import { ReactComponent as EyeIcon } from "assets/icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "assets/icons/eye-off.svg";

import "./SignIn.css";
import Spinner from "components/load/Spinner";

const SignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const token = getCookie("token_auth");
  const { setIsAuthenticated } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const handleAuth = handleSubmit(async (payload) => {
    try {
      const { token } = await authService(payload);
      const expirationDate = new Date();
      expirationDate.setMinutes(expirationDate.getMinutes() + 40);

      setCookie("token_auth", `Bearer ${token}`, {
        path: "/",
        expires: expirationDate,
        secure: true,
        sameSite: "Strict",
      });
      setIsAuthenticated(true); // Actualiza el estado de autenticación
      navigate("/profile");
    } catch (error) {
      toast.error(
        "Usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.",
      );
    }
  });

  useEffect(() => {
    if (token && location.pathname === "/") {
      navigate("/profile");
    }
  }, [token, location.pathname, navigate]);

  return (
    <main className="loginPage">
      <section className="loginLayout">
        {/* Branding */}
        <aside className="loginBrand">
          <SvgIcon className="loginLogo" />
        </aside>

        {/* Formulario */}
        <section className="loginFormSection">
          <form onSubmit={handleAuth} className="loginForm">
            <p className="loginTitle">Login</p>

            {/* Usuario */}
            <div className="loginField">
              <input
                id="cedula"
                type="text"
                placeholder="Usuario"
                className="loginInput"
                autoComplete="username"
                {...register("cedula", {
                  required: {
                    value: true,
                    message: "Debe ingresar un usuario",
                  },
                })}
              />

              {errors?.cedula && (
                <span className="loginError">{errors.cedula.message}</span>
              )}
            </div>

            {/* Contraseña */}
            <div className="loginField">
              <div className="passwordInputWrapper">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  className="loginInput"
                  autoComplete="current-password"
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Debe ingresar una contraseña",
                    },
                  })}
                />

                <button
                  type="button"
                  className="passwordToggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={
                    showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                  }
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>

              {errors?.password && (
                <span className="loginError">{errors.password.message}</span>
              )}
            </div>

            {/* Botón */}
            <button
              type="submit"
              className="loginButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? <Spinner /> : "Ingresar"}
            </button>
          </form>
        </section>
      </section>
    </main>
  );
};

export default SignIn;
